module.exports = __webpack_public_path__ + "static/media/trimex_xaley.0c6a3f99.png";